import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import FromFile from '../../../components/ProposalCreator/FromFile';
import { ProposalCreationStatus } from '../reducer';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		proposalCreator: {
			fromFile: {
				status,
				percentage,
				error,
			},
		},
	} = state;

	return {
		...ownProps,
		isImportingFile: status && [
			ProposalCreationStatus.IMPORTING,
			ProposalCreationStatus.PROCESSING,
		].includes(status),
		importingStatus: status,
		importingPercentage: percentage,
		importingError: error,
	};
};

export default connect(mapStateToProps)(FromFile);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProposalCreator/FromFile/index.tsx